import { useState } from "react";
import TableOrListingContext from "./TableOrListingContext";
import { randomStr } from "../../../utils/helper";

const TableOrListingState = (props) => {
  const [apiData, setApiData] = useState({ data: [], isLoading: false });
  const [isBackgroundColor, setIsBackgroundColor] = useState(false);
  const [fromData, setFormData] = useState({
    title: "",
    filed1: "",
    filed2: "",
    filed3: "",
    date: "",
    filePath: "",
  });
  const [storeIndex, setStoreIndex] = useState("");
  const [isArrayImg, setIsArrayImg] = useState(false);
  const [isSingleImg, setIsSingleImg] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [formDataParent, setFormDataParent] = useState({
    title: "",
    subTitle: "",
    contentMapId: "",
    style: {
      ".multipage-table-section": {
        padding: "50px 0",
        "background-color": { r: 255, g: 255, b: 255, a: 100 },
      },
      ".multipage-table-section.bg-image": {},
      ".multipage-table-section.bg-image::before": {},
      ".multipage-table-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".multipage-table-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: { r: 255, g: 73, b: 124, a: 100 },
        "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
        display: "inline-block",
      },
      ".multipage-table-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: { r: 0, g: 0, b: 0, a: 100 },
      },
      ".multipage-table-section .custom-img": {
        width: "40px",
        height: "40px",
        "border-radius": "50%",
      },
      ".multipage-table-section .table th": {
        border: "1px solid rgba(204, 204, 204, 1)",
        borderPx: "1px",
        borderThik: "solid",
        borderColor: { r: 204, g: 204, b: 204, a: 100 },
      },
      ".multipage-table-section .table td": {
        border: "1px solid rgba(204, 204, 204, 1)",
        borderPx: "1px",
        borderThik: "solid",
        borderColor: { r: 204, g: 204, b: 204, a: 100 },
      },
      custom: "",
    },
  });
  const [collId, setCollId] = useState();
  const [backImageToggle, setBackImageToggle] = useState(false);
  const [boxSection, setBoxSection] = useState(false);
  const [id, setId] = useState("");
  const [childId, setChildId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [filter, setFilter] = useState("");
  const [navMenuId, setNavMenuId] = useState([]);
  const [theme, setTheme] = useState(false);
  const [settingFormData, setSettingFormData] = useState({});
  const [imgShow, setImgShow] = useState(false);
  const [sectionPageName, setSectionPageName] = useState("");

  return (
    <TableOrListingContext.Provider
      value={{
        apiData,
        setApiData,
        fromData,
        setFormData,
        id,
        setId,
        isEdit,
        setIsEdit,
        filter,
        setFilter,
        settingFormData,
        setSettingFormData,
        formDataParent,
        setFormDataParent,
        navMenuId,
        setNavMenuId,
        fromData,
        setFormData,
        childId,
        setChildId,
        theme,
        setTheme,
        boxSection,
        setBoxSection,
        backImageToggle,
        setBackImageToggle,
        collId,
        setCollId,
        isParent,
        setIsParent,
        isBackgroundColor,
        setIsBackgroundColor,
        imgShow,
        setImgShow,
        sectionPageName,
        setSectionPageName,
        storeIndex,
        setStoreIndex,
        isArrayImg,
        setIsArrayImg,
        isSingleImg,
        setIsSingleImg,
      }}
    >
      {props.children}
    </TableOrListingContext.Provider>
  );
};

export default TableOrListingState;
